import {Popup} from '@components/common/popup/popup'
import {useImportFromFileStore} from '@components/import-from-other-services/import-from-file/import-from-file-store'
import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {ErrorPopupFooter} from './error-popup-footer'

export const ErrorPopup = observer(() => {
  const [state, store] = useImportFromFileStore()
  const onClosePopup = () => store.setIsErrorPopupVisible(false)

  return (
    <Popup
      autoHeight
      width={740}
      close={onClosePopup}
      title={Lang.msg.importFromFile.importFromXLSX}
      footer={<ErrorPopupFooter />}
    >
      <div className="text-error-old font-semibold">
        {Lang.msg.common.attention}!
      </div>
      {Lang.msg.importFromFile.foundUnregisteredUsers}
      <div className="bg-main-even-old max-h-256 p-8 mt-16 overflow-auto">
        {state.unregisteredUsers.map((el, i) => (
          <div key={i}>{el}</div>
        ))}
      </div>
    </Popup>
  )
})
